import _ from 'lodash';
import { createSelector } from 'reselect';
import {
  getAuthenticatedProfileId,
  getSelectedProfileId,
  getEditingProfileId
} from './auth.js';

const getProfiles = state => state.profile.all;

const getAccountHoldersProfile = createSelector(
  getProfiles,
  profiles => _.find(profiles, profile => profile.accountHolder)
);

const getProfilesById = createSelector(
  getProfiles,
  profiles => _.keyBy(profiles, 'id')
);

const getSelectedProfile = createSelector(
  getSelectedProfileId,
  getProfiles,
  (profileId, profiles) => _.find(profiles, p => p.id === profileId)
);

const getEditingProfile = createSelector(
  getEditingProfileId,
  getProfiles,
  (profileId, profiles) => _.find(profiles, p => p.id === profileId)
);

const getIsDiaryUnlocked = createSelector(
  getAuthenticatedProfileId,
  getSelectedProfileId,
  (authenticatedProfileId, selectedProfileId) =>
    !!authenticatedProfileId && authenticatedProfileId === selectedProfileId
);

const getIsDiarySetup = createSelector(
  getSelectedProfile,
  profile => profile.email !== null && profile.pin !== null
);

const getIsPrimaryProfile = state => state.profile.all.length === 1;

const getIsEditingCurrentProfile = state =>
  state.auth.profile === state.auth.editingProfile;

const getProfilesListLoading = state => state.profilesList.loading;
const getProfilesPatchLoading = state => state.profilesPatch.loading;
const getProfilesPostLoading = state => state.profilesPost.loading;

const getProfilesLoading = createSelector(
  getProfilesListLoading,
  getProfilesPatchLoading,
  getProfilesPostLoading,
  (listLoading, patchLoading, postLoading) =>
    listLoading || patchLoading || postLoading
);

export {
  getProfiles,
  getProfilesById,
  getSelectedProfile,
  getEditingProfile,
  getIsDiaryUnlocked,
  getIsDiarySetup,
  getIsPrimaryProfile,
  getIsEditingCurrentProfile,
  getAccountHoldersProfile,
  getProfilesLoading
};
